import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

class MobileMenu extends React.Component {
	render() {
		const { loggedIn, userInfo } = this.props;

        return (
			<div className="mobile-menu">

				{!loggedIn ?
					<Link to="/login">
						<div className="top-bar-auth-button login">
							Login
                            </div>
					</Link> : null
				}
				

				{loggedIn ?
					<div className="profile">
						<img className="picture" src="images/profile-picture.png" alt="" />
						<p>{userInfo.epicDisplayName}</p>

						
					</div> : null
				}

				<Link to="/">
					<div className="menu-item">
						<div className="img-holder">
                            <img src="/images/icons/clubhouse.svg" alt="Dashboard" />
						</div>
                                Dashboard
			             </div>
				</Link>
                <Link to="/management">
                    <div className="menu-item">
                        <div className="img-holder">
                            <img src="/images/icons/leaderboard.svg" alt="Management" />
                        </div>
                                Management
	                        </div>
                </Link>

                {loggedIn ?
                    <Link to="/payments">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/wallet.svg" alt="Payments" />
                            </div>
                                Payments
			                </div>
                    </Link>
                    : null
                }
                {loggedIn ?
                    <Link to="/withdrawals">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/settings.svg" alt="Withdrawals" />
                            </div>
                                Widthrawal requests
			                </div>
                    </Link>
                    : null
                }
                <Link to="/users">
                    <div className="menu-item">
                        <div className="img-holder">
                            <img src="/images/icons/faq.svg" alt="Users" />
                        </div>
				                Users
			            </div>
                </Link>
                {loggedIn ?
                    <Link to="/discounts">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/settings.svg" alt="Discounts" />
                            </div>
                                Discounts codes
			                </div>
                    </Link>
                    : null
                }
                <Link to="/challenges">
                    <div className="menu-item">
                        <div className="img-holder">
                            <img src="/images/icons/faq.svg" alt="Challenges" />
                        </div>
				                Finished Challenges
			            </div>
                </Link>
                {loggedIn ?
                    <Link to="/logs">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/settings.svg" alt="Logs" />
                            </div>
                                Logs
			                </div>
                    </Link>
                    : null
                }

                {loggedIn ?
                    <Link to="/logout">
                        <div className="menu-item">
                            <div className="img-holder">
                                <img src="/images/icons/logout.svg" alt="Logout" />
                            </div>
				            Sign out
			            </div>
                    </Link>
                    : null
                }
			</div>
        );
    }
}

function mapStateToProps(state) {
	const { loggedIn, userInfo } = state.userReducer;

	return {
		loggedIn,
		userInfo
    };
}

const mobileMenu = connect(mapStateToProps)(MobileMenu);
export { mobileMenu as MobileMenu }; 